import React, { useState, useEffect } from "react";
import { Row, Col, Card, ButtonGroup, Button, Table, Alert, ProgressBar } from "react-bootstrap";
import Utils from "./../../common/Utils";
import axios from "axios";
import _ from "lodash";
import DateTimePicker from "react-datetime-picker";
import moment from "moment";

const TeamSummary = (props) => {
  const [filter, setFilter] = useState({ pp: Utils.perpage, st: 0, from: moment().startOf('year').toDate(), to: new Date() });
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);

  const addFilter = () => {
    let fltr= `?pp=${filter.pp}&st=${filter.st}`;
    fltr += `&from=`+moment(filter.from).format('YYYY-MM-DD');
    fltr += `&to=`+moment(filter.to).format('YYYY-MM-DD');
    return fltr;
  };

  const loadTeamSummary = () => {
    setLoading(true);
    axios
      .get(Utils.apiUrl("attendence/teamsummary") + addFilter(), Utils.apiHeaders())
      .then((res) => {
        setLoading(false);
        const data = Utils.parseApiResponse(res);
        if (data.success) {
          setTeam(data.data);
          if (_.has(data, "total")) {
            setTotal(data.total);
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(loadTeamSummary, [filter, props.refreshTrigger]);

  const showPagination = ( ) => {
    if (loading || (filter.st === 0 && filter.st +  filter.pp >= total)) {
      return <></>;
    } else {
      return (
        <div className="d-flex flex-row-reverse">
          {filter.st +  filter.pp >= total && (
            <div className="text-disabled ms-2">
              <img
                src={`${process.env.PUBLIC_URL}/images/arrow-right-d.png`}
                alt="Next"
              />{" "}
              Next
            </div>
          )}
          {filter.st +  filter.pp < total && (
            <div
              className="clickable ms-2 text-clickable"
              onClick={() => setFilter({...filter,st:filter.st+filter.pp})}
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/arrow-right.png`}
                alt="Next"
              />{" "}
              Next
            </div>
          )}
          {filter.st >= filter.pp && (
            <div
              className="clickable text-clickable"
              onClick={() => setFilter({...filter,st:filter.st-filter.pp})}
            >
              Previous{" "}
              <img
                src={`${process.env.PUBLIC_URL}/images/arrow-left.png`}
                alt="Previous"
              />
            </div>
          )}
          {filter.st == 0 && (
            <div className="text-disabled">
              Previous{" "}
              <img
                src={`${process.env.PUBLIC_URL}/images/arrow-left-d.png`}
                alt="Previous"
              />
            </div>
          )}
        </div>
      );
    }
  };

  const getPayHours = (u) => {
    const wdh = _.map(_.split(u.wday_hours,','), parseFloat);
    let d = moment(filter.from);
    let hrs = 0;
    while(wdh && d <= moment(filter.to)){
      if(d.day() < wdh.length && !_.isNaN(wdh[d.day()])){
        hrs+=wdh[d.day()];
      }
      d = d.add(1,'days');
    }
    return hrs;
  }

  const exportTeamSummary = () => {
    if (!team || team.length === 0) {
      alert("No attendance data to export for selected dates.");
      return;
    }
    const headers = [
      "Sr. No.",
      "Employee Name",
      "Branch",
      "Extra Hours (Paid)",
      "Unpaid Hours",
      "TIL Hours",
      "Holiday Hours",
      "Total Payroll Hours"
    ];
    const rows = team.map((t, idx) => [
      idx + 1,
      `${t.title || ""} ${t.uname || ""}`.trim() || "—",
      t.branch || "—",
      parseFloat(t.paid || 0),
      parseFloat(t.unpaid || 0),
      parseFloat(t.lieu || 0),
      parseFloat(t.holiday || 0),
      parseFloat(t.payroll || 0)
    ]);
    Utils.exportStyledCsv({
      title: `Team Attendance Summary (${moment(filter.from).format("DD MMM YYYY")} - ${moment(filter.to).format("DD MMM YYYY")})`,
      headers,
      rows,
      filename: `team_attendance_${moment(filter.from).format("YYYYMMDD")}_${moment(filter.to).format("YYYYMMDD")}.csv`
    });
  };

  return (
    <section className="dt-card dt-card--flush mb-4">
      <div className="dt-card__head d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2" style={{ padding: "18px 20px 0", marginBottom: "12px" }}>
        <div>
          <h2 className="dt-card__title">My Team's Attendance Summary</h2>
          <span className="text-muted small">Live clock-in status, locations, and payroll hours</span>
        </div>
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <DateTimePicker
            disableClock={true}
            clearIcon={null}
            format="y-MM-dd"
            onChange={(v) => {
              if (filter.to < v) {
                alert("To date should be greater than or equal to From date");
                return;
              } else {
                setFilter({ ...filter, from: v });
              }
            }}
            value={filter.from}
          />
          <span className="text-muted small fw-bold">To</span>
          <DateTimePicker
            disableClock={true}
            clearIcon={null}
            format="y-MM-dd"
            onChange={(v) => {
              if (filter.from > v) {
                alert("From date should be less than or equal to To date");
                return;
              } else {
                setFilter({ ...filter, to: v });
              }
            }}
            value={filter.to}
          />
        </div>
      </div>
      <div>
        {loading && (
          <div className="p-4 text-center">
            <ProgressBar animated now={100} variant="primary" style={{ height: "6px" }} />
            <p className="mt-2 text-muted small">Loading team attendance...</p>
          </div>
        )}

        {!loading && (
          <>
            {/* Desktop Table */}
            <div className="table-responsive d-none d-md-block">
              <Table striped hover className="text-nowrap dt-table m-0">
                <thead>
                  <tr>
                    <th className="d-table-cell" style={{ width: "60px" }}>Sr. No.</th>
                    <th>Team Member</th>
                    <th className="d-table-cell text-center text-wrap">Extra Hours (Paid)</th>
                    <th className="d-table-cell text-center text-wrap">Unpaid Hours</th>
                    <th className="d-table-cell text-center text-wrap">TIL Hours</th>
                    <th className="d-table-cell text-center text-wrap">Holiday Hours</th>
                    <th className="d-table-cell text-center text-wrap" style={{ color: "var(--dt-navy)" }}>Total Payroll Hours</th>
                  </tr>
                </thead>
                <tbody>
                  {team.map((t, idx) => {
                    return (
                      <tr key={t.uid || idx}>
                        <td className="d-table-cell">
                          <span className="tb-lable tb-lable-warning">{Utils.addZero(filter.st + idx + 1)}.</span>
                        </td>
                        <td>
                          <strong>{t.title} {t.uname}</strong>
                          {t.branch && <div className="text-muted small" style={{ fontSize: "11px" }}>{t.branch}</div>}
                        </td>
                        <td className="d-table-cell text-center num fw-semibold">{t.paid || 0} hrs</td>
                        <td className="d-table-cell text-center num fw-semibold">{t.unpaid || 0} hrs</td>
                        <td className="d-table-cell text-center num fw-semibold">{t.lieu || 0} hrs</td>
                        <td className="d-table-cell text-center num fw-semibold">{t.holiday || 0} hrs</td>
                        <td className="d-table-cell text-center num fw-bold text-primary" style={{ fontSize: "14px" }}>{t.payroll || 0} hrs</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>

            {/* Mobile Cards */}
            <div className="d-md-none p-3 d-flex flex-column gap-3">
              {team.map((t, idx) => (
                <div key={t.uid || idx} className="dt-mobile-record-card">
                  <div className="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
                    <div>
                      <span className="fw-bold text-dark" style={{ fontSize: "14px" }}>
                        #{Utils.addZero(filter.st + idx + 1)}. {t.title} {t.uname}
                      </span>
                      {t.branch && <div className="text-muted small" style={{ fontSize: "10.5px" }}>{t.branch}</div>}
                    </div>
                    <span className="badge bg-primary px-2.5 py-1.5 fw-bold" style={{ fontSize: "12px" }}>
                      Payroll: {t.payroll || 0} hrs
                    </span>
                  </div>

                  <div className="row g-2 mb-1">
                    <div className="col-6 col-sm-3">
                      <div className="p-2 rounded bg-light border text-center">
                        <div className="text-muted small" style={{ fontSize: "10px", fontWeight: 600 }}>EXTRA (PAID)</div>
                        <div className="fw-bold num text-dark" style={{ fontSize: "13px" }}>
                          {t.paid || 0}h
                        </div>
                      </div>
                    </div>
                    <div className="col-6 col-sm-3">
                      <div className="p-2 rounded bg-light border text-center">
                        <div className="text-muted small" style={{ fontSize: "10px", fontWeight: 600 }}>UNPAID</div>
                        <div className="fw-bold num text-danger" style={{ fontSize: "13px" }}>
                          {t.unpaid || 0}h
                        </div>
                      </div>
                    </div>
                    <div className="col-6 col-sm-3">
                      <div className="p-2 rounded bg-light border text-center">
                        <div className="text-muted small" style={{ fontSize: "10px", fontWeight: 600 }}>TIL (IN LIEU)</div>
                        <div className="fw-bold num text-info" style={{ fontSize: "13px" }}>
                          {t.lieu || 0}h
                        </div>
                      </div>
                    </div>
                    <div className="col-6 col-sm-3">
                      <div className="p-2 rounded bg-light border text-center">
                        <div className="text-muted small" style={{ fontSize: "10px", fontWeight: 600 }}>HOLIDAY</div>
                        <div className="fw-bold num text-success" style={{ fontSize: "13px" }}>
                          {t.holiday || 0}h
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="p-3">
              {showPagination()}
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default TeamSummary;
